<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <div class="page">
        <transition name="slidedown">
          <div v-if="crumbsVisible" class="page-crumbs">
            <nav class="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <router-link
                  :key="`crumb_${crumb.name}`"
                  v-for="crumb in $route.meta.crumbs"
                  :to="{ name: crumb.name }"
                  tag="li"
                >
                  <a
                    ><span class="link">{{ crumb.label }}</span></a
                  >
                </router-link>
                <li v-if="gallery" class="is-active">
                  <a href="#" aria-current="page">Blooming</a>
                </li>
              </ul>
            </nav>
          </div>
        </transition>
        <section class="page-section" v-if="!gallery">
          Loading...
        </section>
        <section class="page-section" v-if="gallery">
          <div class="section-heading">
            <h1>Plants currently in bloom</h1>
            <div class="">
              Last update
              <i title="few days ago">few days ago</i>
            </div>
          </div>
          <div class="page-section-content" style="font-size: 1.5rem;">
            <div
              style="margin: 0 .75rem 0 .75rem;"
              class="columns is-multiline"
            >
              <div
                :key="`plant_${plant.id}`"
                class="column is-3"
                v-for="plant in gallery.plants"
              >
                <a
                  :href="
                    `https://registr.bz-uk.roamingowl.com/map?plant=${plant.id}`
                  "
                  target="_blank"
                  :title="`${plant.name_lat} - click to show location`"
                >
                  <div class="card" style="position: relative;">
                    <div class="card-image">
                      <figure style="overflow: hidden;">
                        <div
                          :style="`backgroundImage: url('${getImage(plant)}');`"
                          class="image is-4by3 plant-image"
                          :alt="plant.name_lat"
                        />
                      </figure>
                    </div>
                    <div class="card-content fixed-bottom">
                      <div class="content">
                        <div
                          :title="plant.name_lat"
                          style="font-size: 1.5rem; line-height: 1.5rem;"
                          class="truncate"
                        >
                          {{ plant.name_lat }}
                        </div>
                        <template v-if="plant.name">
                          <div
                            :title="plant.name"
                            style="font-size: .9rem; line-height: 1.5rem;"
                            class="subtitle truncate"
                          >
                            {{ plant.name }}
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </page>
</template>
<script>
//https://register.bz-uk.roamingowl.com/widgets/dp-gallery/bc3ebc3c-253e-43a9-9243-a763708d013g
import Page from "./../common/page";
import Resource from "./../../services/blooming";
import { format } from "timeago.js";

export default {
  data() {
    return {
      gallery: null,
      crumbsVisible: false
    };
  },
  methods: {
    timeAgo(date) {
      return format(date);
    },
    getImage(plant) {
      let keys = Object.keys(plant.images);
      return plant.images[keys[0]].url;
    }
  },
  components: {
    Page
  },
  metaInfo: {
    title: "Is blooming"
  },
  async mounted() {
    this.gallery = await Resource.get(); //????
    this.crumbsVisible = true;
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(25vw - 4rem);
}

.subtitle {
  margin-top: 0.5rem;
}

.fixed-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 0.8rem;
}

.plant-image {
  background-size: cover;
  transition: transform 0.2s;

  &:hover {
    transform: scale3d(1.03, 1.03, 1.03);
    transition: transform 0.2s;
  }
}

.link {
  color: #008cde;
  cursor: pointer;

  &:hover {
    @include link-underline(#e1e1e1, #008cde, $color-selection);
  }
}
</style>
